// extracted by mini-css-extract-plugin
export default {"section":"es-z","inSectionButton":"fs-z","addressCard":"gs-z","disabled":"hs-z","cautionBox":"is-z","failureBox":"js-z","fade-out":"ks-z","successBox":"ls-z"};